import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import ClubManage from './Manage';
import ClubView from './View';

class Clubs extends Component {
    render() {
        return (
            <Switch>
                <Route exact path={`${this.props.match.url}`} component={ClubManage} />
                <Route exact path={`${this.props.match.url}/:id`} component={ClubView} />
            </Switch>
        );
    }
}

export default Clubs;
